import { Sound as CommonSound } from "common/sound";
import * as R from "ramda";
export async function loadSound(src) {
    try {
        return await CommonSound.load({
            sheetPath: src,
            sprite: spriteForHowler,
            loopNameMapper,
        });
    }
    catch (e) {
        console.error(e);
        throw e;
    }
}
const loopNameMapper = (loopName) => {
    switch (loopName) {
        case "chatbotBgm":
            return ["chatbotBgm"];
        case "chatbotTicketEffect1":
            return ["chatbotTicketEffect1"];
        case "chatbotTicketEffect2":
            return ["chatbotTicketEffect2"];
    }
};
const sprite = {
    chatbotBgm: [0 + 2 / 30, 4 + 9 / 30],
    chatbotEffect1: [5, 5 + 8 / 30],
    chatbotEffect2: [6 + 17 / 30, 7],
    chatbotEffect3: [8 + 4 / 30, 8 + 13 / 30],
    chatbotNatashaAppear: [18 + 12 / 30, 19 + 15 / 30],
    chatbotTicketEffect1: [9 + 5 / 30, 13 + 15 / 30],
    chatbotTicketEffect2: [13 + 27 / 30, 15 + 1 / 30],
    chatbotTicketTouchEffect: [15 + 11 / 30, 18 + 6 / 30],
};
const spriteForHowler = R.map(([start, end]) => [
    Math.floor(start * 1000),
    Math.floor(end * 1000 - start * 1000),
], sprite);
//# sourceMappingURL=chatbotSound.js.map